import CirugiasService from "@/services/CirugiasService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const cirugia = {
    namespace:true,
    state: {cirugias:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListCirugia({commit},pageNumber){
            return await CirugiasService.getlist(pageNumber).then(
                response=>{    
                    commit('setCirugias',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListCirugia({commit},search){          
            return await CirugiasService.getSearch(search).then (
                response =>{                    
                    commit('setCirugias',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setCirugias(state,data){
        state.cirugias = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.cirugias.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};